import React from 'react'
import PropTypes from 'prop-types'

const ErrorText = ({ message }) => {
  if (!message) return null
  return (
    <p className='se-error' role='alert'>
      {message}
    </p>
  )
}

ErrorText.propTypes = {
  message: PropTypes.string,
}

export default ErrorText
